import React from 'react';
import ImageGallery from '../components/ImageGallery';
import SEOHeadNative from '../components/SEOHeadNative';

const Batiment: React.FC = () => {
  const galleryImages = [
    {
      src: '/images/batiment/isolation-rockwool.jpg',
      title: 'Isolation thermique',
      description: 'Isolation haute performance avec laine de roche de qualité supérieure'
    },
    {
      src: '/images/batiment/parquet-pose.jpg',
      title: 'Pose de parquet',
      description: 'Installation professionnelle de revêtements de sol durables'
    },
    {
      src: '/images/batiment/renovation-3.jpg',
      title: 'Finitions intérieures',
      description: 'Travaux de finition soignés avec attention aux détails'
    },
    {
      src: '/images/batiment/finition-interieure.jpg',
      title: 'Rénovation complète',
      description: 'Aménagement intérieur moderne avec finitions de qualité'
    },
    {
      src: '/images/batiment/isolation-2.jpg',
      title: 'Isolation intérieure',
      description: 'Travaux d\'isolation pour une meilleure efficacité énergétique'
    },
    {
      src: '/images/batiment/renovation-3.jpg',
      title: 'Rénovation d\'appartement',
      description: 'Transformation complète d\'espaces de vie'
    },
    {
      src: '/images/batiment/renovation-4.jpg',
      title: 'Aménagement sur mesure',
      description: 'Création d\'espaces fonctionnels et esthétiques'
    },
    {
      src: '/images/batiment/finition-5.jpg',
      title: 'Finitions haut de gamme',
      description: 'Attention portée aux détails pour un résultat impeccable'
    }
  ];

  return (
    <div>
      <SEOHeadNative
        title="Bâtiment Général - OZARKSELEC"
        description="Entreprise générale de bâtiment à Viesly. Rénovation complète, isolation thermique, pose de revêtements, finitions intérieures. Expertise électricité + bâtiment avec un interlocuteur unique."
        keywords="entreprise bâtiment Viesly, rénovation Aisne, isolation thermique, pose parquet, finitions intérieures, bâtiment général Nord"
        canonical="/batiment"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Bâtiment Général",
          "description": "Rénovation complète, isolation thermique, pose de revêtements, finitions intérieures. Expertise électricité + bâtiment avec un interlocuteur unique.",
          "provider": {
            "@type": "ElectricalContractor",
            "name": "OZARKS ELEC",
            "url": "https://ozarkselec.com"
          },
          "areaServed": ["Aisne", "Thiérache", "Caudrésis", "Catésis", "Nord"],
          "serviceType": "Bâtiment général"
        }}
      />
      <div className="r t-rec t-rec_pt_90 t-rec_pb_90" style={{paddingTop: '90px', paddingBottom: '90px'}}>
        <div className="t-container">
          <div className="t-col t-col_8 t-prefix_2">
            <div className="t-align_center">
              <h1 className="t-title t-title_xs ozarks-blue-dark">
                Bâtiment <span className="ozarks-blue-medium">Général</span>
              </h1>
              
              <div style={{marginTop: '60px', textAlign: 'left'}}>
                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>🏠 Rénovation complète</h3>
                  <p className="ozarks-gray" style={{lineHeight: '1.7'}}>
                    OZARKSELEC élargit ses compétences au bâtiment général. Nous réalisons vos projets de 
                    rénovation intérieure avec le même niveau d'exigence que pour nos installations électriques.
                  </p>
                </div>

                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>🧱 Isolation thermique</h3>
                  <p className="ozarks-gray" style={{lineHeight: '1.7'}}>
                    Nous utilisons des matériaux de qualité supérieure comme la laine de roche 
                    pour garantir une isolation performante et durable de vos espaces.
                  </p>
                </div>

                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>🪵 Revêtements de sol</h3>
                  <p className="ozarks-gray" style={{lineHeight: '1.7'}}>
                    Pose de parquet et revêtements de sol. Nous maîtrisons les techniques 
                    modernes pour des finitions soignées et durables.
                  </p>
                </div>

                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>✨ Finitions intérieures</h3>
                  <p className="ozarks-gray" style={{lineHeight: '1.7'}}>
                    Aménagements intérieurs complets : cloisons, peinture, menuiserie intérieure. 
                    Chaque détail est soigné pour un résultat professionnel.
                  </p>
                </div>

                <div style={{backgroundColor: 'var(--ozarks-light-gray)', padding: '20px', borderRadius: '10px', marginTop: '40px'}}>
                  <h4 className="ozarks-blue-dark" style={{marginBottom: '15px'}}>💡 L'avantage OZARKSELEC</h4>
                  <p className="ozarks-gray" style={{lineHeight: '1.7', marginBottom: '0'}}>
                    <strong>Un interlocuteur unique</strong> pour vos projets électricité + bâtiment. 
                    Coordination optimale, délais maîtrisés et expertise reconnue dans les deux domaines.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Galerie interactive de réalisations */}
      <div className="r t-rec t-rec_pt_60 t-rec_pb_60" style={{paddingTop: '60px', paddingBottom: '60px', backgroundColor: 'var(--ozarks-light-gray)'}}>
        <div className="t-container">
          <div className="t-col t-col_12">
            <div className="t-section__title t-title t-title_xs t-align_center t-margin_auto">
              <div style={{fontSize: '32px'}} className="ozarks-blue-dark">
                Galerie de nos <span className="ozarks-blue-medium">réalisations</span>
              </div>
              <div className="t-descr t-descr_xl t-margin_auto" style={{marginTop: '15px', color: 'var(--ozarks-gray)', maxWidth: '600px'}}>
                Découvrez quelques-unes de nos réalisations en bâtiment général. 
                Cliquez sur les images pour les voir en grand format.
              </div>
            </div>
            
            <ImageGallery images={galleryImages} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Batiment;